import { useEffect, useState } from 'react';
import { getTimer } from '../../utils/Data/customizeConnector';

const usePreviewCustomizeTimer = () => {
  const [timer, setTimer] = useState({
    endTime: null,
  });
  useEffect(() => {
    (async () => {
      try {
        const res = await getTimer();
        setTimer({
          endTime: res.data.endTime,
        });
      } catch (err) {
        setTimer({ endTime: null });
      }
    })();
  }, []);
  return timer;
};

export default usePreviewCustomizeTimer;
